/**
 * BlocKPIs (zone [4]) — 2 à 3 tuiles chiffrées. Valeur = seul élément « fort »
 * (text-lg tabular-nums). Masqué entier si aucune tuile (règle anti-tuiles-vides).
 * « — » toléré UNIQUEMENT ici (jamais dans un `dl`).
 */

import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { SummaryIcon } from '../primitives'
import { formatSummaryValue, toneKpiClass } from '../primitives.helpers'
import type { SummaryKpi } from '../types'

export function SummaryKpis({ kpis }: { kpis: SummaryKpi[] }) {
    const { t, i18n } = useTranslation()
    if (kpis.length === 0) return null
    const cols = kpis.length >= 3 ? 'grid-cols-3' : kpis.length === 2 ? 'grid-cols-2' : 'grid-cols-1'

    return (
        <dl className={cn('grid gap-2', cols)}>
            {kpis.map((k) => {
                const value = k.value
                    ? formatSummaryValue(k.value, k.format, k.currency, i18n.language)
                    : '—'
                return (
                    <div key={k.key} className="rounded-lg border border-border p-3">
                        {/* ⚠️ Le libellé était `truncate` : à trois tuiles, la colonne
                            fait ~110 px et « Durée (minutes) » devenait « Durée (… »,
                            « Seuil de réussite » → « Seuil de r… ». Un libellé coupé
                            ne dit plus ce qu'il compte. Il passe donc à la ligne —
                            l'icône reste alignée en haut (`items-start` + `mt-px`). */}
                        <dt className="flex items-start gap-1.5 text-[11px] leading-tight text-muted-foreground">
                            <SummaryIcon
                                name={k.icon}
                                className="mt-px h-3.5 w-3.5 shrink-0 text-primary"
                            />
                            <span className="min-w-0">{t(k.label, k.label)}</span>
                        </dt>
                        <dd
                            className={cn(
                                'mt-1 text-lg font-semibold tabular-nums',
                                toneKpiClass(k.tone),
                            )}
                        >
                            {value}
                        </dd>
                    </div>
                )
            })}
        </dl>
    )
}
